import {
  createPartner,
  deleteAllPartners,
  deleteRowService,
  getPartners,
  restoreAllPartners,
  restoreRowService,
  softDeletePartner,
  softDeleteAllPartners,
  updatePartner,
} from "../../services/partners";
import {
  partnersLoading,
  partnersError,
  setPartnersList,
} from "../../slices/partnersSlice";

export const getAction = () => async (dispatch) => {
  dispatch(partnersLoading());
  try {
    const response = await getPartners();
    if (response?.error) {
      dispatch(partnersError(response.error));
      return;
    } else {
      dispatch(setPartnersList(response));
      return;
    }
  } catch (error) {
    dispatch(partnersError(error.message));
    return;
  }
};

export const createAction = (formData) => async (dispatch) => {
  dispatch(partnersLoading());
  try {
    const response = await createPartner(formData);
    if (response?.error) {
      dispatch(partnersError(response.error));
      return;
    } else {
      dispatch(getAction());
      return;
    }
  } catch (error) {
    dispatch(partnersError(error.message));
    return;
  }
};

export const updateAction = (formData) => async (dispatch) => {
  const table = formData.get("table");
  const id = formData.get("id");
  dispatch(partnersLoading());
  try {
    const response = await updatePartner(formData);

    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        partnersError(`Failed to update row with ID ${id} in ${table} table`)
      );
      return;
    }
  } catch (error) {
    dispatch(partnersError(error.message));
    return;
  }
};

export const softDeleteAction = (table, id, username) => async (dispatch) => {
  dispatch(partnersLoading());
  try {
    const response = await softDeletePartner(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        partnersError(
          `Failed to softdelete row with ID ${id} in ${table} table`
        )
      );
      return;
    }
  } catch (error) {
    dispatch(partnersError(error.message));
    return;
  }
};

export const softDeleteAllAction = (table, username) => async (dispatch) => {
  dispatch(partnersLoading());
  try {
    const response = await softDeleteAllPartners(table, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(partnersError(`Failed to delete records in ${table} table`));
      return;
    }
  } catch (error) {
    dispatch(partnersError(error.message));
    return;
  }
};

export const deleteRowAction = (table, id, username) => async (dispatch) => {
  dispatch(partnersLoading());
  try {
    const response = await deleteRowService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        partnersError(`Failed to delete row with ID ${id} in table ${table}`)
      );
      return;
    }
  } catch (error) {
    dispatch(partnersError(error.message));
    return;
  }
};

export const deleteAllAction = (table, type, username) => async (dispatch) => {
  dispatch(partnersLoading());
  try {
    const response = await deleteAllPartners(table, type, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        partnersError(
          `Failed to delete records in ${table} table of type ${type}`
        )
      );
      return;
    }
  } catch (error) {
    dispatch(partnersError(error.message));
    return;
  }
};

export const restoreRowAction = (table, id, username) => async (dispatch) => {
  dispatch(partnersLoading());
  try {
    const response = await restoreRowService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        partnersError(`Failed to recover row with ID ${id} in ${table} table`)
      );
      return;
    }
  } catch (error) {
    dispatch(partnersError(error.message));
    return;
  }
};

export const restoreAllAction = (table, type, username) => async (dispatch) => {
  dispatch(partnersLoading());
  try {
    const response = await restoreAllPartners(table, type, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        partnersError(
          `Failed to recover records in ${table} table of type ${type}`
        )
      );
      return;
    }
  } catch (error) {
    dispatch(partnersError(error.message));
    return;
  }
};
